// extracted by mini-css-extract-plugin
export var GradientLoader = "GradientLoader-module--GradientLoader--E_Bcw";
export var MoveBackground = "GradientLoader-module--MoveBackground--3-t9i";